<template>
    <div style="z-index: 0;">
        <!-- 鼠标移上时的显示 -->
        <div class="mouserover-div" v-show="center_shwo" :class="[{onlineStyle:data.status==0, offlineStyle:data.status==1,alarmStyle:data.status==2,people:typeof(data.status)=='undefined'}]">
            <img class="close_img" :src="'../../static/img/close.png'" @click="closeClick()"/>
          <div v-if='type!==99'>
                <div :class="[{onlineRealPos:data.status==0, offlineRealPos:data.status==1,alarmRealPos:data.status==2,peopleName:typeof(data.status)=='undefined'}]">{{data.deviceName}}</div>
                <div v-for="(item,index) in data.nowState" :key="index">
                    <span style="font-weight: bold;font-size: 14px;">{{item.key}}</span><span> < {{item.val}} ></span></br>
                </div>
                <p align="center" style="font-weight: bold;font-size: 14px;color: #8cc5ff" @click="showTag()" v-show="data.nowState!=undefined &&data.nowState.length>5?true:false">更多</p>
            </div>

            <div v-if='type==4'>
                <!-- <span>姓名:{{data.userName}}</span></br>
                <span>联系电话:{{data.userPhone}}</span></br>
                <a style="cursor:pointer;" @click="handleXunjian">《 查看巡检轨迹 》</a></br> -->
            </div>
            <div class="xunjian_box" v-if="is_xunjian_model">
                <xunjian :show-dialog="is_xunjian_model" @closeDialog='closeXunjianDialog' :positionData="position_data" :userId="data.userId"></xunjian>
            </div>

        </div>
      <span class="triangle bottom" :class="[{bottom1:data.status==0, bottom0:data.status==1,bottom2:data.status==2,people:typeof(data.status)=='undefined'}]" v-show="center_shwo"></span>

    </div>
</template> 

<script>
    import {mapState, mapMutations} from 'vuex';
    import dataUrl from '../../../../libs/js/interfaceAddress.js';
    import xunjian from '../../xunjian/xunjian_line'

    export default {
        name: 'map_info_content',
        data() {
            return {
                map: {},
                data: {},
                imgData: [],
                type: 0,
                num:5,
                //巡检弹框设置
                is_xunjian_model:false,
                position_data:[],
                center_shwo:true

            }
        },
        components:{
            xunjian
        },
        created() {

        },
        mounted() {
        },
        computed: {

        },
        methods: {
          ...mapMutations(['set_userId']),

            //点击查看巡检轨迹
            handleXunjian(){
                var userId = this.data.userId;
                this.xunjianLine(userId);
            },
            //关闭巡检模态框
            closeXunjianDialog(){
                this.is_xunjian_model = false;
            },
            showTag(){
              this.num = this.data.nowState.length;
                this.$forceUpdate()
            },
            closeClick(){
            this.center_shwo = false;
            },
            xunjianLine(userId){
                this.is_xunjian_model = true;
                this.$http.post(dataUrl.interfaceAddress.getPos, {
                  userId:userId,
                  start:'',
                  end:'',
                }).then(res => {
                  if (res.data && res.data.code === 1) {
                    if(res.data.data.length>0){
                      this.position_data = res.data.data;
                    } else {
                      this.position_data=[];
                    }
                  }

                }).catch((err) => {
                  console.log(err)
                  // reject(err)
                })
            },
        }
    }
</script>

<style scoped lang='less'>

  .close_img {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;

    }
    .triangle {
        width: 0;
      height: 0;
      position: absolute;
        z-index: 1;
        border-width: 15px;
        border-style: solid;
        border-color: transparent;
    }
    .bottom {
        /*border-top-color: #d66c5c;*/
        bottom: -22px;
        left: 58%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);

    }
    .bottom0 {
        border-top-color: rgba(255,255,255,.6);
    }
    .bottom1 {
        border-top-color:rgba(26, 250, 41, 0.6);
    }
    .bottom2 {
        border-top-color: rgba(255,0,0,.5);
    }
    .onlineStyle{
        background-color:rgba(26, 250, 41, 0.6);
    }
    .offlineStyle{
        background-color:rgba(255,255,255,.6)
    }
    .alarmStyle{
        background-color:rgba(255,0,0,.5)
    }
    .people{
        /*backgroun  d-:#92875f;*/
        /*background-color:rgba(146,135,95,.9)*/
        background-color:rgba(236,107,6,.7)

        /*ec6b06*/
    }
    .onlineRealPos{
        font-size: 17px;
        border-bottom: 1px solid rgba(26, 250, 41, 0.6);
    }
    .offlineRealPos{
        font-size: 17px;
        border-bottom: 1px solid rgba(255,255,255,.8);
    }
    .alarmRealPos{
        font-size: 17px;
        border-bottom: 1px solid rgba(255,0,0,.8);
    }
    .peopleName{
        font-size: 17px;
        border-bottom: none;

        /*ec6b06*/
    }
    .mouserover-div{
        min-width: 200px;
        min-height:50px;
        padding:10px;
        color:#fff;
        font-size: 14px;
        border-radius:10px;
        span{
            float: left;
            padding-left: 5px;
            padding-right: 5px;
        }
        .xunjian_box{
            position: absolute;
            width: 900px;
            height: 700px;
            top:50%;
            left:40%;
        }

    }
</style>





// WEBPACK FOOTER //
// src/page/main_content/map/baseMap/map_info_content.vue